'use strict';

import * as d3 from 'd3';

const CTN_WRAPPER_CLASSNAME = 'wrapper';
const CTN_X_AXIS_CONTAINER_CLASSNAME = 'container-x-axis';
const CTN_X_AXIS_WRAPPER_CLASSNAME = 'wrapper-x-axis';

export function renderContainer (chartContainerEle, width, height, heightByData, margin, options) {
  const isXAxisFixed = options && options.isXAxisFixed;
  const chartContainerWidth = width + margin.left + margin.right;
  let chartContainerHeight = heightByData + margin.top + margin.bottom;
  const chartWrapperWidth = chartContainerWidth;
  let chartWrapperHeight = chartContainerHeight;
  if (isXAxisFixed === true) {
    chartContainerHeight = heightByData < height ? heightByData + margin.top : height;
    chartWrapperHeight = heightByData + margin.top;
  }

  const $chartContainer = d3.select(chartContainerEle)
    .style('width', `${chartContainerWidth}px`)
    .style('height', `${chartContainerHeight}px`);
  const joinedSvg = $chartContainer.selectAll('svg').data([0]);
  const svgEnter = joinedSvg
    .enter()
    .append('svg')
    .attr('width', chartWrapperWidth)
    .attr('height', chartWrapperHeight)
    .style('display', 'block');
  joinedSvg
    .transition().duration(options.transitionDuration)
    .attr('width', chartWrapperWidth)
    .attr('height', chartWrapperHeight);
  joinedSvg
    .exit()
    .transition().duration(options.transitionDuration)
    .remove();
  const svg = svgEnter.merge(joinedSvg);
  const joinedWrapper = svg.selectAll(`.${CTN_WRAPPER_CLASSNAME}`).data([0]);
  joinedWrapper
    .enter()
    .append('g')
    .attr('class', CTN_WRAPPER_CLASSNAME)
    .attr('transform', `translate(${margin.left}, ${margin.top})`);
  joinedWrapper
    .transition().duration(options.transitionDuration)
    .attr('transform', `translate(${margin.left}, ${margin.top})`);
  joinedWrapper
    .exit()
    .transition().duration(options.transitionDuration)
    .remove();
  const $chartWrapper = $chartContainer.select(`.${CTN_WRAPPER_CLASSNAME}`);
  // const $chartWrapper = $chartContainer
  //   .append('svg')
  //   .attr('width', chartWrapperWidth)
  //   .attr('height', chartWrapperHeight)
  //   .style('display', 'block')
  //   .append('g')
  //   .attr('transform', `translate(${margin.left}, ${margin.top})`);
  let $xAxisContainer;
  let $xAxisWrapper;
  let xAxisWrapperHeight;
  if (options && options.isXAxisFixed === true) {
    const parentEle = chartContainerEle.parentNode;
    const xAxisContainerEle = document.createElement('div');
    xAxisWrapperHeight = options.hasXAxisLabel === true ? 45 : 30;
    xAxisContainerEle.classList.add(CTN_X_AXIS_CONTAINER_CLASSNAME);
    parentEle.insertBefore(xAxisContainerEle, null);
    $xAxisContainer = d3.select(xAxisContainerEle)
      .style('width', `${chartContainerWidth}px`)
      .style('height', `${xAxisWrapperHeight}px`);
    $chartContainer
      .style('overflow-y', 'auto')
      .style('overflow-x', 'hidden');
    const joinedXAxisSvg = $xAxisContainer.selectAll('svg').data([0]);
    const xAxisSvgEnter = joinedXAxisSvg
      .enter()
      .append('svg')
      .attr('width', chartContainerWidth)
      .attr('height', xAxisWrapperHeight);
    joinedXAxisSvg
      .transition().duration(options.transitionDuration)
      .attr('width', chartContainerWidth)
      .attr('height', xAxisWrapperHeight);
    joinedXAxisSvg
      .transition().duration(options.transitionDuration)
      .remove();
    const xAxisSvg = xAxisSvgEnter.merge(joinedXAxisSvg);
    const joinedXAxisWrapper = xAxisSvg.selectAll(`.${CTN_X_AXIS_WRAPPER_CLASSNAME}`).data([0]);
    joinedXAxisWrapper
      .enter()
      .append('g')
      .attr('class', CTN_X_AXIS_WRAPPER_CLASSNAME)
      .attr('transform', 'translate(' + margin.left + ', 0)');
    joinedXAxisWrapper
      .transition().duration(options.transitionDuration)
      .attr('transform', 'translate(' + margin.left + ', 0)');
    joinedXAxisWrapper
      .transition().duration(options.transitionDuration)
      .remove();
    // $xAxisWrapper = $xAxisContainer
    //   .append('svg')
    //   .attr('width', chartContainerWidth)
    //   .attr('height', xAxisWrapperHeight)
    //   .append('g')
    //   .attr('transform', 'translate(' + margin.left + ', 0)');
    $xAxisWrapper = $xAxisContainer.select(`.${CTN_X_AXIS_WRAPPER_CLASSNAME}`);
  }

  return {
    chartContainerWidth: chartContainerWidth,
    chartContainerHeight: chartContainerHeight,
    chartWrapperWidth: chartWrapperWidth,
    chartWrapperHeight: chartWrapperHeight,
    xAxisWrapperHeight: xAxisWrapperHeight,
    $chartContainer: $chartContainer,
    $chartWrapper: $chartWrapper,
    $xAxisContainer: $xAxisContainer,
    $xAxisWrapper: $xAxisWrapper
  };
}

export function removeContainer (chartContainerEle, options = {}) {
  const parentEle = chartContainerEle.parentNode;
  const xAxisContainerEle = parentEle.querySelector(`.${CTN_X_AXIS_CONTAINER_CLASSNAME}`);
  if (xAxisContainerEle !== null) { xAxisContainerEle.remove(); }
  chartContainerEle.style.overflow = null;
  for (const children of chartContainerEle.childNodes) {
    children.remove();
  }
}

export default {
  CTN_WRAPPER_CLASSNAME,
  CTN_X_AXIS_CONTAINER_CLASSNAME,
  CTN_X_AXIS_WRAPPER_CLASSNAME,
  renderContainer: renderContainer,
  removeContainer: removeContainer
};
